module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_7.0c54a770.pdf";